<template>
  <router-view />
</template>

<script>
export default {
  name: 'User',

  created() {
    this.initialized = true;
    this.emitter.$emit('initFavicon');
  },
};
</script>
